module.exports = "<p class=\"validation-wrapper\">\n  <ng-content select=\"validation\"></ng-content>\n</p>\n"